/**
 * HTML Utilities
 *
 * Shared utility functions for HTML entity handling.
 *
 * @package SuperPymeCheckoutBlocks
 * @since 1.14.0
 */

/**
 * Decode HTML entities in a string.
 *
 * Uses WordPress's htmlEntities if available, otherwise falls back
 * to textarea trick for browser-native decoding.
 *
 * @param {string} value - String with potential HTML entities
 * @returns {string} Decoded string
 */
export function decodeEntities(value) {
    if (!value) {
        return '';
    }
    if (window.wp?.htmlEntities?.decodeEntities) {
        return window.wp.htmlEntities.decodeEntities(value);
    }
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
}

/**
 * Escape HTML to prevent XSS.
 *
 * Uses DOM textContent to safely escape HTML characters.
 *
 * @param {string} text - String to escape
 * @returns {string} Escaped string safe for innerHTML
 */
export function escapeHtml(text) {
    if (!text) {
        return '';
    }
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}
